@if (developerMode) {
    <div style="display:inline-flex;margin-left:8px;margin-right:8px;">
        <div>
            @if (panels?.length > 0) {
                <label
                        soho-label
                        [required]="true"
                >{{ 'GenAIPanelsSelectAllMessage' | translate }}</label>
                @for (panel of panels; track panel) {
                    <div>
                        <input
                                type="checkbox" soho-checkbox
                                id={{panel.panelName}}
                                data-automation-id="lm-genai-dialog-summarize"
                                name={{panel.panelName}}
                                [(ngModel)]="panel.selected">
                        <!--                (change)="onChange($event)"-->
                        <!--            >-->
                        <label for={{panel.panelName}}>{{ panel.panelTitle }}</label>
                    </div>
                }
            }
            @if (panels?.length === 0) {
                <label
                        soho-label
                        for="lm-default-prompt"
                >{{ 'KeyPointsLabel' | translate }}</label>
                <textarea style="width: 300px;"
                          name="lm-default-prompt"
                          id="lm-default-prompt"
                          soho-textarea
                          class="lm-genai-prompt-textarea"
                          data-automation-id="lm-genai-input"
                          [(ngModel)]="defaultGenAIPrompt.value"
                          attr.aria-label="{{ 'KeyPoints' | translate }}">
              </textarea>
                <label style="margin-top: 10px;"
                       soho-label
                       for="lm-prompt-label"
                >{{ 'AdditionalKeyPointsLabel' | translate }}</label>
                <textarea style="width: 300px;"
                          name="lm-prompt-label"
                          id="lm-prompt-label"
                          soho-textarea
                          placeholder="{{ 'GenAIPlaceholderText' | translate }}"
                          class="lm-genai-prompt-textarea"
                          data-automation-id="lm-genai-input"
                          [(ngModel)]="genAIPrompt.value"
                          attr.aria-label="{{ 'KeyPoints' | translate }}">
              </textarea>
                @if (printOptions?.length > 0) {
                    <div class="pdf-criteria field">
                        <label style="margin-top: 10px;" soho-label for="printOption">{{'GenAISummaryOptions' | translate}}</label>
                        <select soho-dropdown
                                id="printOption"
                                data-automation-id="lm-print-to-pdf-print-option"
                                soho-trackdirty
                                class="dropdown-md"
                                (ngModelChange)="onPrintOptionChanged($event)"
                                [ngModel]="printOption.value">
                            >
                            @for (option of printOptions; track option) {
                                <option [value]="option.value">{{option.label}}</option>
                            }
                        </select>
                    </div>
                }
            }
            <div class="field">
                <label soho-label for="llmModel">{{ 'GenAISummaryModel' | translate }}</label>
                <select soho-dropdown
                        id="llmModel"
                        name="llmModel"
                        data-automation-id="lm-genai-llm-model"
                        [(ngModel)]="llmModel"
                        soho-alert>
                    @for (obj of llmModels; track obj) {
                        <option [value]="obj.value">{{obj.label}}</option>
                    }
                </select>
            </div>
            <button #generateButton
                soho-button="primary-generative"
                icon="insights-smart-panel"
                iconAlign="end"
                generativeAnimation = "100000000"
                data-automation-id="lm-genai-button"
                style="justify-content: center; margin-top: 20px; min-width: 306px;"
                (click)="generate($event)"
            ><span>{{ 'GenerateAIButton' | translate }}</span>
            </button>
        </div>
        <div class="editor-container is-readonly">
            <label
                soho-label
                for="lm-genai-text-devmode"
            >{{ 'GenAISummaryTitle' | translate }}</label>
            <div id="lm-genai-loading-wrapper-dev"></div>
            <textarea
                soho-textarea
                [readOnly]="true"
                name="lm-genai-text-devmode"
                id="lm-genai-text-devmode"
                style="min-width: 704px; height: 325px"
                data-automation-id="lm-genai-text"
                [(ngModel)]="summaryField.value"
                attr.aria-label="{{ 'GenAI' | translate }}">
          </textarea>
<!--            <div-->
<!--                name="lm-genai-text-devmode"-->
<!--                id="lm-genai-text-devmode"-->
<!--                data-automation-id="lm-genai-text"-->
<!--                soho-editor-->
<!--                disabled="true"-->
<!--                class="lm-genai-prompt-editor"-->
<!--                soho-alert-->

<!--                [(ngModel)]="summaryField.value"-->
<!--                attr.aria-label="{{ 'GenAI' | translate }}">-->
<!--            </div>-->
        </div>
    </div>
    <div class="tag-container lm-genai-disclaimer">
        <span lm-field-style class="tag" style="height: auto;">{{'GeneratedAIDisclaimerMessage' | translate}}</span>
    </div>
} @else {
    <div class="editor-container is-readonly">
        <label
            soho-label
            for="lm-genai-text"
        >{{ 'GenAISummaryTitle' | translate }}</label>
        <div id="lm-genai-loading-wrapper"></div>
        <textarea
                soho-textarea
                [readOnly]="true"
                name="lm-genai-text"
                id="lm-genai-text"
                data-automation-id="lm-genai-text"
                [(ngModel)]="summaryField.value"
                attr.aria-label="{{ 'GenAI' | translate }}">
          </textarea>
<!--        <div-->
<!--            name="lm-genai-text"-->
<!--            id="lm-genai-text"-->
<!--            data-automation-id="lm-genai-text"-->
<!--            soho-editor-->
<!--            disabled="true"-->
<!--            class="lm-genai-prompt-editor"-->
<!--            soho-alert-->

<!--            [(ngModel)]="summaryField.value"-->
<!--            attr.aria-label="{{ 'GenAI' | translate }}">-->
<!--        </div>-->
    </div>
    <div class="tag-container lm-genai-disclaimer">
        <span lm-field-style class="tag" style="height: auto;">{{'GeneratedAIDisclaimerMessage' | translate}}</span>
    </div>
}